import { Conditional } from "@result/rui/components";
import PropTypes from "prop-types";
import React from "react";

export default function ErrorPage({ errorCode = 404, errorMessage }) {
  return (
    <div className="main-content">
      <h1 className="title is-3">Error {errorCode}</h1>
      <Conditional condition={errorMessage}>
        <p>{errorMessage}</p>
      </Conditional>
    </div>
  );
}

ErrorPage.propTypes = {
  errorCode: PropTypes.number,
  errorMessage: PropTypes.string,
};
